<template>
  <div class="direct-call">
    <EcsCallWidget :interaction="interaction" />
  </div>
</template>

<script>
import EcsCallWidget from '@/components/ecs-call-widget/EcsCallWidget.vue';

export default {
  name: 'EcsDirectCall',

  components: {
    EcsCallWidget
  },

  props: {
    interaction: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  computed: {},

  methods: {}
};
</script>

<style scoped>
.direct-call {
  height: 100%;
  position: relative;
  background-color: var(--v-surface-darken1);
}
</style>
